import { FullWidthLoadingFallback } from '@omnea-app/frontend/components/shared/Loading/components/LoadingFallbacks'
import { CustomErrorBoundary } from '@omnea-app/frontend/utils/error-boundary/CustomErrorBoundary'
import { NotFoundBoundary } from '@omnea-app/frontend/utils/error-boundary/NotFoundBoundary'
import { assertNever } from '@omnea-app/packages/universal/type-guards/assertNever'
import { RecordAccessProvider } from './RecordAccessProvider'
import type { AnyRecordAccess } from './useRecordAccess'
import type { ReactNode } from 'react'

type Props = {
  access: AnyRecordAccess
  children: ReactNode
}

export const RecordAccessGate = ({ access, children }: Props) => {
  switch (access.status) {
    case 'unavailable':
      return <CustomErrorBoundary errorData={{ error: access.error }} resourceType={access.entity} />
    case 'loading':
      return <FullWidthLoadingFallback />
    case 'resolved':
      // Not-found, not forbidden: a denied caller must not learn that the record exists.
      if (!access.permissions.canView) return <NotFoundBoundary />
      return <RecordAccessProvider access={access}>{children}</RecordAccessProvider>
    case 'role':
      return <RecordAccessProvider access={access}>{children}</RecordAccessProvider>
    default:
      return assertNever(access)
  }
}
